import React from 'react';
import { motion } from 'framer-motion';
import { DECK } from '@/constants/testIds';

export default function ChapterRail({ segments, activeIndex, onJump }) {
  return (
    <nav
      data-testid={DECK.chapterRail}
      aria-label="Chapter index"
      // Moved from the LEFT edge to the RIGHT edge so the active chapter label
      // no longer collides with the segment titles (which live on the left
      // half of the deck via the rail='left' layout in SegmentSection).
      className="hidden lg:flex fixed right-5 top-1/2 -translate-y-1/2 z-40 flex-col gap-3.5 items-end"
    >
      {segments.map((s, i) => (
        <button
          key={s.id}
          type="button"
          onClick={() => onJump(i)}
          // flex-row-reverse: the dot stays on the OUTER edge (rightmost),
          // and the active label expands INWARD toward the deck — into the
          // empty right-side gutter rather than over the title text.
          className="group relative flex flex-row-reverse items-center gap-3 outline-none"
          aria-label={`Jump to chapter ${s.number} — ${s.title}`}
          data-testid={`chapter-jump-${s.id}`}
        >
          <span className={`chapter-dot ${i === activeIndex ? 'active' : ''}`} />
          <motion.span
            initial={false}
            // Slide IN from the right (x: +4 → 0) instead of from the left.
            animate={{ opacity: i === activeIndex ? 1 : 0, x: i === activeIndex ? 0 : 4 }}
            transition={{ duration: 0.25 }}
            className="font-ui text-[11px] tracking-[0.28em] uppercase text-[color:var(--gold)] whitespace-nowrap text-right"
          >
            {s.number} · {s.title}
          </motion.span>
        </button>
      ))}
    </nav>
  );
}
